// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"1b51da52","817":"3bf510e6"}[chunkId] + ".css";
};